import React from 'react'

import type { StandardRecipeItem } from '@library/api-menu-experience'

import { TileImage as RecipeTileImage } from '../../RecipeTileImage/TileImage'
import { DietaryBadgeRow } from './DietaryBadgeRow'
import { ImageContainer } from '../RecipeTile.styles'
import { SoldOutOverlay } from '../SoldOutOverlay'

type RecipeTileImageSectionProps = {
  recipe: StandardRecipeItem
  isOutOfStock: boolean
  lazy: boolean
  insideOverflow: boolean
}

export const RecipeTileImageSection = ({
  recipe,
  isOutOfStock,
  lazy,
  insideOverflow,
}: RecipeTileImageSectionProps) => (
  <ImageContainer>
    <SoldOutOverlay isOutOfStock={isOutOfStock} />
    <RecipeTileImage
      lazy={lazy}
      recipe={{
        images: [
          {
            ...recipe.image,
            type: recipe.image.type ?? 'image',
          },
        ],
        name: recipe.title,
      }}
      insideOverflow={insideOverflow}
      testId="recipe-tile-image"
    />
    <DietaryBadgeRow recipe={recipe} />
  </ImageContainer>
)
